import React from 'react'

const HomePage = () => {
    return (
        <div className="header">HomePage</div>
    )
}

export default HomePage